import { useContext } from "react";
import { AuthContext } from "../../index.js";
import { Navigate, useLocation } from "react-router-dom";
import { isEmpty } from "../../Utils/utils.js";

const RequiresAuth = ({ children }) => {
  const { authState } = useContext(AuthContext);
  const location = useLocation();
  return !isEmpty(authState.mobile) ? (
    children
  ) : (
    <Navigate to="/login" state={{ from: location }} />
  );
};
export { RequiresAuth };
